export default __webpack_public_path__ + "static/media/rune.feae1051.png";